import { render, staticRenderFns } from "./AlertsTable.vue?vue&type=template&id=1b32268f&"
import script from "./AlertsTable.vue?vue&type=script&lang=js&"
export * from "./AlertsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b32268f')) {
      api.createRecord('1b32268f', component.options)
    } else {
      api.reload('1b32268f', component.options)
    }
    module.hot.accept("./AlertsTable.vue?vue&type=template&id=1b32268f&", function () {
      api.rerender('1b32268f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alerts/AlertsTable.vue"
export default component.exports